import React, { useMemo } from 'react';

import Animate from 'components/organisms/Animate';
import Banner from 'components/organisms/Banner';
import { baseURL } from 'utils/functions';

interface BannerHomeProps {
  banners: BannersDataTypes[]
  handleScrollDown?: () => void;
}

const BannerHome: React.FC<BannerHomeProps> = ({
  banners,
  handleScrollDown,
}) => {
  const bannersData = useMemo(() => banners?.map(({ data }) => ({
    title: data?.title,
    description: data?.subTitle,
    imageDesktop: baseURL(data?.imageDesktop),
    imageMobile: baseURL(data?.imageMobile),
    imageTablet: baseURL(data?.imageTablet),
    link: data?.link,
    videoMobile: data?.videoMobile,
    videoTablet: data?.videoTablet,
    videoDesktop: data?.videoDesktop,
    video: data?.video,
  })), [banners]);

  return (
    <Animate extendClassName="p-home_banner" type="fadeIn">
      <Banner
        data={bannersData}
        handleScrollDown={handleScrollDown}
      />
    </Animate>
  );
};

BannerHome.defaultProps = {
  handleScrollDown: undefined,
};

export default BannerHome;
